module.exports = __webpack_public_path__ + "img/history.6a763826.png";